import React from 'react';
import { midas } from '@resurs/midas';
import { classNames } from '@resurs/hephaestus';
const Columns = ({ children, justifyCenter = false }) => (React.createElement("div", { className: classNames(midas.columns, justifyCenter && midas.justifyCenter) }, children));
export default Columns;
